import { render } from "./KWNew.vue?vue&type=template&id=3ab799a2"
import script from "./KWNew.vue?vue&type=script&lang=js"
export * from "./KWNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__